﻿(function() {
    "use strict";

    angular.module("app").controller("ProjectsController", ProjectsController);

    ProjectsController.$inject = ["constants"];

    function ProjectsController(constants) {
        var vm = this

        vm.constants = constants;

        vm.$onInit = onInit;

        function onInit() {
            vm.deleted = location.hash.indexOf('/deleted') > -1
        }
    }

})();
